import React, { useEffect, useState } from "react";
import { Button, Link } from "@icg360/design-system";
import PT from "prop-types";

import { settings } from "../../units/load-live-chat";

import type { ButtonSize } from "@icg360/design-system/dist/src/components/button";

type ChatButton8x8Props = {
  buttonSize?: ButtonSize;
  useLink?: boolean;
};

export const ChatButton8x8 = ({
  buttonSize = "xs",
  useLink = false,
  ...props
}: ChatButton8x8Props) => {
  const [iframe, setIframe] = useState(null);

  useEffect(() => {
    if (settings) {
      scrapeChatInfo();
      window.addEventListener("message", handleIframeMessage);
    }

    return () => {
      if (settings) {
        window.removeEventListener("message", handleIframeMessage);
      }
    };
  }, []);

  const scrapeChatInfo = () => {
    const iframe = document.querySelectorAll(
      `iframe[src^="${settings.domain}"]`
    ) as NodeListOf<HTMLIFrameElement>;

    if (iframe.length) {
      setIframe(iframe[0].contentWindow);
    }
  };

  const handleClick = () => {
    if (iframe) {
      iframe.postMessage(
        JSON.stringify({
          topic: "button:click",
          data: {
            asPopout: false
          }
        }),
        settings.domain
      );
    }
  };

  const handleIframeMessage = e => {
    if (e.origin === settings.domain) {
      try {
        const { topic } = JSON.parse(e.data);
        if (topic === "chat:loaded") {
          setTimeout(scrapeChatInfo, 1000);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  if (!settings) return null;
  if (useLink) {
    return (
      <span {...props} id="live-chat-link" data-bdd="live-chat-link">
        <Link onClick={handleClick}>live chat</Link>
      </span>
    );
  }
  return (
    <div {...props} id="live-chat-link" data-bdd="live-chat-link">
      <Button
        appearance="secondary"
        leadingIcon="Chat"
        size={buttonSize}
        onClick={handleClick}
      >
        Live chat
      </Button>
    </div>
  );
};

ChatButton8x8.propTypes = {
  buttonSize: PT.string,
  useLink: PT.bool
};
